module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UNirkOVuhpOqc.ff3904f6.woff2";